import { clear_token, get_token, get_user_details , set_user_details } from "@/router";
import { client_domain } from "@/main.js";
import Swal from 'sweetalert2';
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import NotificationDropdown from '@/components/Notifications/Notification.vue'
import HomeSidebar from '@/components/HomeSidebar/HomeSidebar.vue'
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
import Cart from '@/components/cart/CartView.vue';
import { view_profile_product } from "@/views/Marketplace/marketplace_helpers";
import { view_profile as view_profile_helper } from "@/views/home/home_helper.js";

export default {

  components: {
    NotificationDropdown,
    HomeSidebar,
    MenuSideBar,
    Cart,
    StickyNav
  },
  inject: ['client_features'],
  computed: {
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    isHomeFilterOrViewPortal() {
      return this.$route.name === 'home_filter' || this.$route.name === 'view_portal'|| this.$route.name === 'view_events';
    },
    firstNameInitial() {
      return this.userDetails.first_name.charAt(0);
    },
    visibleBaseProfiles() {
      const profiles = this.base_profiles || [];
      const activePersonalProfile = profiles.find(p => p.profile_type === 'personal');

      // Filter out duplicate personal profiles
      const uniqueProfiles = profiles.filter((profile, index, self) => {
        return (
          profile.profile_type !== 'personal' || // Keep non-personal profiles
          index === self.findIndex(p => p.profile_type === 'personal' && p.id === profile.id) // Keep only the first unique personal profile
        );
      });

      let result = uniqueProfiles.slice();

      result = result.filter((profile, index, self) => {
        return (
          profile.profile_type !== 'personal' || // Keep non-personal profiles
          (activePersonalProfile ? profile.id === activePersonalProfile.id : index === self.findIndex(p => p.profile_type === 'personal')) // Keep only the active personal profile or the first one
        );
      });

      return this.showAll ? result : result.slice(0, 3);
    },

    activeBaseProfile() {
      return this.base_profiles.find(profile => profile.is_active) || null;
    },
    visibleProfiles() {
      if (!this.filteredProfiles || !this.filteredProfiles.profiles) {
        return [];
      }

      return this.expandedSection === 'people'
        ? this.filteredProfiles.profiles
        : this.filteredProfiles.profiles.slice(0, 3);
    },
    computed: {
    has_any_results() {
      const lists = [
        this.filteredRecent,
        this.filteredProfiles?.profiles,
        this.filteredProfiles?.companies,
        this.filteredProfiles?.portals,
        this.filteredProfiles?.reports,
        this.filteredProfiles?.products
      ]

      return lists.some(list => Array.isArray(list) && list.length > 0)
    }

  },
  visibleCompanies() {
    if (!this.filteredProfiles.companies) return [];
    return this.expandedSection === 'companies'
      ? this.filteredProfiles.companies
      : this.filteredProfiles.companies.slice(0, 3);
  },
  visiblePortals() {
    if (!this.filteredProfiles.portals) return [];
    return this.expandedSection === 'portals'
      ? this.filteredProfiles.portals
      : this.filteredProfiles.portals.slice(0, 3);
  },
  visibleReports() {
    if (!this.filteredProfiles.reports) return [];
    return this.expandedSection === 'reports'
      ? this.filteredProfiles.reports
      : this.filteredProfiles.reports.slice(0, 3);
  },
  visible_products() {
    if (!this.filteredProfiles.products) return [];
    return this.expandedSection === 'products'
      ? this.filteredProfiles.products
      : this.filteredProfiles.products.slice(0, 3);
  },

  },

  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.loadGoogleMapEvent();
    this.user_id = this.get_user_id();
    this.fetch_type_of_organization();
    this.fetch_type_of_profile();
    this.get_all_profile();
    this.fetchProfiles();
    this.toggleShowAll();
    this.getActiveProfile();
    this.getSearchHistory();
    document.addEventListener("click", this.handleOutsideClick);

    if(client_domain.includes('cbo') ||client_domain.includes('tdm') || client_domain.includes('chamber') ||
    client_domain.includes('demo') ||client_domain.includes('engagenet') || client_domain.includes('dwypd') ||
    client_domain.includes('bosa') || client_domain.includes('apex') || client_domain.includes('vettedsa')) {
      this.visible_domain = true;
      $('#company_profile_modal').on('hidden.bs.modal', () => {
        this.update_first_time_login_status();
      });
    }
    if (client_domain.includes('vettedsa') || client_domain.includes('engagenet')) {
      this.marketplace_domain = true;
    }
    if (client_domain.includes('vettedsa')) {
      this.vettedsa_domain = true;
    }

    if(client_domain.includes('workbook')) {
      this.workbook_domain = true;
    }
    if(client_domain.includes('chiefluthuli')) {
      this.school_domain = true;
    }
    if(client_domain.includes('soulcity') || client_domain.includes('nsp') || client_domain.includes('dwypd') || client_domain.includes('aicreads') ) {
      this.soulcity_domain = true;
    }
    if(client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }

    this.$nextTick(() => {
      const home_nav_offcanvas = document.getElementById('offcanvasExample');
      if (!home_nav_offcanvas) return;

      this.home_nav_offcanvas_show_handler = () => {
        this.$el?.classList?.add('home-nav-offcanvas-active');
      };
      this.home_nav_offcanvas_hidden_handler = () => {
        this.$el?.classList?.remove('home-nav-offcanvas-active');
      };

      home_nav_offcanvas.addEventListener('show.bs.offcanvas', this.home_nav_offcanvas_show_handler);
      home_nav_offcanvas.addEventListener('hidden.bs.offcanvas', this.home_nav_offcanvas_hidden_handler);
    });

  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
    const home_nav_offcanvas = document.getElementById('offcanvasExample');
    if (home_nav_offcanvas) {
      home_nav_offcanvas.removeEventListener('show.bs.offcanvas', this.home_nav_offcanvas_show_handler);
      home_nav_offcanvas.removeEventListener('hidden.bs.offcanvas', this.home_nav_offcanvas_hidden_handler);
    }
  },
  watch: {
    activeBaseProfile: {
      immediate: true,
      handler(newProfile) {
        this.$emit('active_profile', newProfile);
      }
    }
    
  },
  data() {
    return ({
       expandedSection: null,
      searchHistory: [],
      filteredRecent: [],
      token_exists: false,
      user_id:null,
      cbo_domain: false,
      visible_domain: false,
      user_details: {
        "user_role":'',
        "first_name":'',
        "last_name":'',
      },
      showMenu: false,
      show_cart:false,
      showIcons: false,
      showSearch: false,
      users: [], // Add profiles data property
      filteredProfiles: [],
      searchQuery: '',
      isSidebarOpen: false,
      isEventSidebarOpen: false,
      company_name: '',
      type_of_organization: [],
      description: '',
      email: '',
      tell_number: '',
      location: '',
      organizationTypes: [],
      errors: {},
      isLoading: false,
      profile_switch_loading: false,
      selected_type_of_organization: '',
      type_of_profile: [],
      selectedProfile: null,
      base_profiles: [],
      currentProfile: null,
      displayLetter: '',
      displayName: '',
      isBusinessProfile: false,
      companyData: null,
      showAll: false,
      profile_questions: [],
      workbook_domain: false,
      searchTimeout: null,
      is_edit_mode:false,
      base_profile_id: null,
      longitude:null,
      latitude:null,
      receive_emails: true,
      receive_notifications: true,
      showNotificationSettings: false,
      soulcity_domain: false,
      school_domain: false,
      marketplace_domain: false,
      vettedsa_domain: false,
    });
  },

  watch: {
    searchQuery() {
      this.filterProfiles();
    },
    activeBaseProfile: {
      immediate: true,
      handler(newProfile) {
        this.$emit('active_profile', newProfile);
      }
    }
  },
  methods: {
    closeHomeNavOffcanvas() {
      $('#offcanvasExample').offcanvas('hide');
    },

   openManageBusiness() {
  $('#offcanvasExample').offcanvas('hide')

  setTimeout(() => {
    $('#manageBusinessModal').modal('show')
  }, 300)
},

openCompanyProfileModal() {
   $('#offcanvasExample').offcanvas('hide')

  setTimeout(() => {
    $('#company_profile_modal').modal('show')
  }, 300)
},
    toggleMenu(e){
      $('.dropdown-menu.show').each(function () {
        $(this).removeClass('show');
        $(this).closest('.dropdown').find('[data-bs-toggle="dropdown"]').attr('aria-expanded', 'false');
      });
      this.showMenu = !this.showMenu;
      e.stopPropagation();
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.showMenu = false;
      }
    },
    openManageBusinessModal() {
      $('#manageBusinessModal').modal('show');
    },
    delete_company_profile(profile_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This will permanently delete the company profile.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_user_company_profile/`,
            type: 'DELETE',
            headers: {
              Authorization: `Token ${get_token()}`,
              'Content-Type': 'application/json'
            },
            data: JSON.stringify({profile_id: profile_id}),
            success: (response) => {
              if (response.status === 'success') {
                Swal.fire({
                  title: 'Deleted!',
                  text: response.message,
                  icon: 'success',
                  timer: 1500,
                  showConfirmButton: false,
                  position: 'bottom-end',
                  toast: true
                });

                // Find the deleted profile object
                const deleted_profile = this.base_profiles.find(p => p.id === profile_id);

                // Remove the deleted profile from the source list
                this.base_profiles = this.base_profiles.filter(p => p.id !== profile_id);

                // Close modal
                $('#manageBusinessModal').modal('hide');

                // If deleted profile was active and business type, switch to personal profile
                if (deleted_profile && deleted_profile.is_active && deleted_profile.profile_type === this.typeOfProfileId('business')) {
                  // Find active personal profile
                  const personalProfile = this.base_profiles.find(p => p.profile_type === this.typeOfProfileId('personal'));

                  if (personalProfile) {
                    // Switch to personal profile via your existing switch method
                    this.switchProfile(personalProfile.id, false); // pass false to avoid loading indicator if you want
                  }
                }
              }
            },
            error: (err) => {
              Swal.fire({
                title: 'Error!',
                text: err.responseJSON?.message || 'Something went wrong',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },


    open_edit_profile(business) {
    this.is_edit_mode = true;

    this.company_name = business.company_name;
    this.selected_type_of_organization = business.type_of_organization;
    this.description = business.description || "";
    this.email = business.email || "";
    this.tell_number = business.tell_number || "";
    this.location = business.location || "";
    this.base_profile_id= business.base_profile.id;
    $('#company_profile_modal').modal('show');
    this.$nextTick(() => {
      if (this.$refs.quillCompanyEditorRef) {
        const quillEditor = this.$refs.quillCompanyEditorRef.getQuill();
        if (quillEditor) {
          quillEditor.clipboard.dangerouslyPasteHTML(this.description);
        }
      }
    });
  },
  loadGoogleMapEvent() {
      if (!isNaN(this.latitude) && !isNaN(this.longitude)) {
        if (typeof window.google === 'undefined' || !window.google.maps) {

          const script = document.createElement('script');
          script.id = 'googleMapsScript';
          script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places&callback=initMap&v=weekly`;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);

          window.initMap = () => {
            this.initializeMap();
          };
        }
      }
    },
  update_company_profile(){
     if (!this.validateForm()) {
          return;
        }
      Swal.fire({
          title: 'Updating...',
          text: 'Please wait while we update the company profile.',
          allowOutsideClick: false,
          didOpen: () => {
              Swal.showLoading();
          }
      });

      this.isLoading = true;
      const formData = new FormData();
      formData.append('base_profile_id',this.base_profile_id);
      formData.append('company_name', this.company_name);
      formData.append('type_of_organization_id', this.selected_type_of_organization);
      this.description = this.$refs.quillCompanyEditorRef.getHTML()
      formData.append('description', this.description);
      formData.append('email', this.email);
      formData.append('tell_number', this.tell_number);
      formData.append('location', this.location);

      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_user_company/`,
          type: 'POST',
          headers: {
              Authorization: `Token ${get_token()}`,
          },
          data: formData,
          processData: false,
          contentType: false,
          success: (response) => {
              if (response.status === 'success') {
                this.$emit('profile_updated');

                  Swal.fire({
                      title: 'Success',
                      text: 'Company Profile Updated Successfully',
                      icon: 'success',
                      timer: 1000,
                      showConfirmButton: false,
                      position: 'bottom-end',
                      toast: true
                  }).then(() => {
                    $('#company_profile_modal').modal('hide');
                  });
              }
          },
          error: (error) => {
              console.error('Error:', error);
              Swal.fire({
                  title: 'Error',
                  text: 'An error occurred while updating the profile',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
              });
          },
          complete: () => {
            this.clear_company_form()
              this.isLoading = false;
          },
      });
  },
    toggleSidebars() {
      if (this.isEventsPage) {
        this.toggleEventSidebar(); // Toggle the event sidebar
      } else {
        this.toggleHomeSidebar(); // Toggle the main sidebar
      }
    },
    toggleEventSidebar() {
      this.isEventSidebarOpen = !this.isEventSidebarOpen; // Toggle event sidebar
    },
    toggleHomeSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen; // Toggle main sidebar
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
  },
  typeOfProfileId(name) {
    const profileType = this.type_of_profile.find(type => type.name.toLowerCase() === name.toLowerCase());
    return profileType ? profileType.id : null;
  },
    logout_user() {
      Swal.fire({
        title: 'Are you sure?',
        text: "Are you sure you want to logout?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, log out!',
        position: 'bottom-end',
        toast: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          clear_token();
          if (client_domain.includes('dwypd')){
            window.location = `/knowledgehub`;
          }else{
          window.location = `/sign_in_finale`;
          }
        }
      });
    },
    toggleIcons() {
      this.showIcons = !this.showIcons;
    },

    get_all_profile() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_users/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: {user_id: this.user_id},
        success: (data) => {
          this.users = data.data.users_list;
        }
      }
      )},
    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
    clear_search_dropdown() {
      this.searchQuery = '';
      this.filteredRecent = [];
      this.filteredProfiles = null;
      this.showSearch = false;
      $(document).off("click.recent");
    },
    update_first_time_login_status() {
          $.ajax({
              type: 'POST',
              url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_first_time_login/`,
              contentType: 'application/json',
              headers: {
                  'Authorization': `Token ${get_token()}`,
              },

              success: (response) => {
                  var response_data = response.data;
                  set_user_details(response_data.user_details);
              }
          });
      },
      applyHistory(history) {
    this.searchQuery = history;
    this.filterProfiles(); // re-run search
  },
  show_recent() {
  this.filteredRecent = this.searchHistory ? [...this.searchHistory] : [];

  if (!this.filteredProfiles) this.filteredProfiles = [];

  $(document).off("click.recent").on("click.recent", (e) => {
    if (!$(e.target).closest(".topbarnav, .search-bar").length) {
      this.showSearch = false;
      this.filteredRecent = [];
      this.filteredProfiles = null;
      $(document).off("click.recent");
    }
  });
},
displayTags(tags) {
    if (!tags) return [];
    if (this.searchQuery) {
      const matched = tags.filter(tag =>
        tag.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
      if (matched.length) {
        // return only matched tag names
        return matched.map(t => t.name);
      }
    }
    // default: return first 2 tag names
    return tags.slice(0, 2).map(t => t.name);
  },
  getSearchHistory() {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_search_history/`,
      type: 'GET',
      headers: {
        Authorization: `Token ${get_token()}`
      },
       success: (response) => {
      if (response.status === 'success') {
        if (response.data && Array.isArray(response.data)) {
          this.searchHistory = response.data.slice(0, 5);
        } else {
          this.searchHistory = []
        }
      }
    },
      error: (err) => {
        console.error('Failed to fetch search history', err);
      }
    });
  },
  createSearchHistory() {
    
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_search_history/`,
      type: 'POST',
      headers: {
        Authorization: `Token ${get_token()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        query: this.searchQuery,
        user_id: this.user_details.user_id
      }),
      success: (response) => {
        if (response.status === 'success') {
          if (!this.searchHistory.includes(this.searchQuery)) {
            this.searchHistory.unshift(this.searchQuery);
            if (this.searchHistory.length > 10) this.searchHistory.pop();
          }
        }
      },
      error: (err) => {
        console.error('Failed to save search history', err);
      }
    });
  },

   removeHistory(historyId) {

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/delete_search_history/`,
      type: 'DELETE',
      headers: {
        Authorization: `Token ${get_token()}`
      },
      data:{
        history_id:historyId
      },
      success: (response) => {
        if (response.status === 'success') {
          this.filteredRecent = this.filteredRecent.filter(item => item.id !== historyId);
        }
      }
    });
  },
    filterProfiles() {
    // Clear any previous timeout so only the LAST keystroke triggers the request
    clearTimeout(this.searchTimeout);

    if (this.searchQuery && this.searchQuery.length >= 3) {
        this.isLoading = true;
        this.searchTimeout = setTimeout(() => {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/global_search_api/`,
                type: 'POST',
                headers: {
                    Authorization: `Token ${get_token()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({
                    query: this.searchQuery
                }),
                success: (response) => {
                    if (response.status === 'success') {
                        const data = response.data || {};
                        if (Array.isArray(data.portals)) {
                            data.portals = data.portals.filter(
                                portal => portal.name?.toLowerCase() !== 'default portal'
                            );
                        }
                      this.filteredProfiles = response.data;
                        this.filteredRecent = this.searchHistory.filter(h =>
                            h.query.toLowerCase().includes(this.searchQuery.toLowerCase())
                        );
                    }
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        }, 3000); // <--- 3 seconds
    } else {
        this.filteredProfiles = [];
        this.filteredRecent = this.searchHistory;
    }
},



 view_profile(profile) {
        this.createSearchHistory();
      view_profile_helper(this.$router, profile);
    },

      view_report(report) {
        this.createSearchHistory()

        window.location = `/home?report_id=${report.id}`;

  },


  view_product_details(product){
    this.createSearchHistory();
      view_profile_product(this.$router, product);
    },

  toggleExpand(section) {
    this.expandedSection =
      this.expandedSection === section ? null : section;
  },
  displayedDescription(report) {
  if (!report.description) return '';

  // 1. Remove HTML tags
  let text = report.description.replace(/<[^>]*>/g, '');

  // 2. Collapse multiple spaces/newlines into a single space
  text = text.replace(/\s+/g, ' ').trim();

  // 3. Take at least the first 10 characters
  if (text.length <= 30) {
    return text;
  } else {
    return text.substring(0, 30) + '...';
  }
},

      control_switching_profile(base_profile){

        if(client_domain.includes('cbo')){
          this.view_profile_nav(base_profile)
        }
        else{

          this.switchProfile(base_profile.id);
        }
      },

      view_profile_nav(base_profile){
        const base = base_profile.id;
        const type = base_profile.profile_type;
        window.location = `/profile?base=${base}&type=${type}`;
      },
      view_portal(portal){
        this.createSearchHistory()
          if (portal?.portal_type?.name === 'incident') {
            this.$router.push({ name: 'view_incidents', params: { portal_id: portal.portal_id, portal_name:portal.name,} });
          }
          else if(portal?.portal_type?.name === 'publishing'){
             this.$router.push({ name: 'publish_portal', params: { portal_id: portal.id, portal_name:portal.name,} });
          }
           else
            this.$router.push({ name: 'view_portal', params: { portal_id: portal.id, portal_name: portal.name, is_public:portal.is_public } });

      },

      initializeMap() {
      const defaultLat = parseFloat(this.latitude || 0);
      const defaultLng = parseFloat(this.longitude || 0);

      const mapOptions = {
        center: { lat: defaultLat, lng: defaultLng },
        zoom: 8,
        mapTypeId: 'roadmap',
      };

      const mapElement = document.querySelector('#mapSearchBox');
      if (mapElement) {
        const map = new window.google.maps.Map(mapElement, mapOptions);

        let marker = null;

        const input = document.getElementById('mapSearchBox');
        const searchBox = new window.google.maps.places.SearchBox(input);

        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

        map.addListener('bounds_changed', () => {
          searchBox.setBounds(map.getBounds());
        });

        searchBox.addListener('places_changed', () => {
          const places = searchBox.getPlaces();

          if (!places || places.length === 0) {
            return;
          }

          const place = places[0];
          if (!place.geometry) {
            return;
          }

          // Update map center and zoom
          map.setCenter(place.geometry.location);
          map.setZoom(14);

          // Remove the existing marker, if any
          if (marker) {
            marker.setMap(null);
          }

          marker = new window.google.maps.Marker({
            position: place.geometry.location,
            map: map,
            title: place.name,
          });
          this.location = input.value;
          this.$emit('location_selected', input.value);
        });
      }
    },
    myLearningView() {
      let programe_name;

      if (client_domain.includes('workstreams') || client_domain.includes('demo')) {
          programe_name = 'workstreams learning';
      } else if (client_domain.includes('919')) {
          programe_name = '919 learning';
      } else if (client_domain.includes('chamber')) {
          programe_name = 'ICT Chamber learning';
      } else if (client_domain.includes('community')) {
          programe_name = 'Funax Community learning';
      }else if (client_domain.includes('workbook')) {
          programe_name = 'IC workbook learning';
      }
      else {
          programe_name = 'workstreams learning';
      }

  },

    open_maintenance() {
      if (!this.token_exists) {
          this.$router.push('/sign_in_finale');
          return;
      }
      this.$router.push('/incident_reporting');
    },
    fetchProfiles() {

      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
          type: 'POST',
          headers: {
              Authorization: `Token ${get_token()}`,
              'Content-Type': 'application/json',
          },
          success: (response) => {
              if (response.status === 'success' && response.data.profiles) {
                  this.base_profiles = response.data.profiles;
                  this.$emit('active_profile', this.activeBaseProfile);
              }
          },
      });
  },
  clearPersonalData() {
      this.email = '';
      this.phone_number = '';
  },

  switchProfile(profileId,isLoading = true) {
    const selectedProfile = this.base_profiles.find(profile => profile.id === profileId);
  if (selectedProfile && selectedProfile.is_active) {
    window.location='/profile'
    return;
  }
    this.isLoading = isLoading;
    this.profile_switch_loading = isLoading;

    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/switch_profile/`,
        method: 'POST',
        headers: {
            Authorization: `Token ${get_token()}`,
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({ profile_id: profileId ,user_id:this.user_id}),
          success: (response) => {
            if (response.status === 'success') {

              this.getActiveProfile();

              this.base_profiles.forEach(profile => {
                profile.is_active = profile.id === profileId;
              });
            }
          },
          error: (xhr, status, error) => {
            console.error("Error switching profile:", error);
          },
          complete: () => {
            // Delay the loading state completion by 3 seconds
            setTimeout(() => {
              this.isLoading = false;
              this.profile_switch_loading = false;
              window.location = `/profile`;
            }, 2000);
          },
    });
  },

  getActiveProfile() {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_active_profile/`,
      type: "GET",
      headers: {
        Authorization: `Token ${get_token()}`,
        "Content-Type": "application/json",
      },
      success: (response) => {
        if (response.status === "success") {
          this.currentProfile = response.data;
          this.$emit('active-profile-loaded', this.currentProfile)
          const profileTypeName = response.data.profile_type?.toLowerCase();

          if (profileTypeName === 'business' && response.data.is_active) {
            this.clearPersonalData();
            this.isBusinessProfile = true;
          } else {
            this.receive_emails = this.currentProfile.user?.receive_emails;
            this.receive_notifications = this.currentProfile.user?.receive_notifications;
            this.isBusinessProfile = false;
            this.companyData = null;
          }

        }
      },
      error: (xhr, status, error) => {
        console.error("Error fetching active profile:", error);
      },
    });
  },

  toggleShowAll() {
    this.showAll = !this.showAll;
  },
  fetch_type_of_profile() {

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
      type: 'GET',
      headers: {
        Authorization: `Token ${get_token()}`,
        'Content-Type': 'application/json',
      },
      success: (response) => {
        if (response.status === 'success') {
          this.type_of_profile = response.data.type_of_profile_data;
          // this.show_questions();
        }
      },

    });
  },
  go_to_unified_search() {
    if (this.searchQuery && this.searchQuery.length > 0) {
      this.showSearch = false;
      this.filteredProfiles = [];
      this.$router.push({ name: 'unified_search', query: { q: this.searchQuery } })
      }
    },


//   show_questions() {
//   const businessProfile = this.type_of_profile.find(
//     (profile) => profile.name?.toLowerCase() === 'business'
//   );

//   if (!businessProfile || !businessProfile.id) {
//     console.error("Business profile not found or invalid.");
//     return;
//   }

//   const payload = {
//     filter_values: {
//       profile_type_id: businessProfile.id,
//     },
//   };

//   $.ajax({
//     url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
//     type: "POST",
//     headers: {
//       Authorization: `Token ${get_token()}`,
//       "Content-Type": "application/json",
//     },
//     data: JSON.stringify(payload),
//     success: (response) => {
//       this.profile_questions =response.data
//       this.$emit('questions_fetched', this.profile_questions)
//     },
//     error: (xhr, status, err) => {
//       console.error("Failed to fetch questions:", err);
//     }
//   });
// },


update_answer(questionId, value) {
  const questionSection = this.profile_questions
    ?.flatMap(f => f?.form?.form_sections || [])
    ?.flatMap(s => s?.section?.question_sections || [])
    ?.find(qs => qs?.question?.id === questionId);

  if (questionSection) {
    questionSection.answer = value;
  }
},

      toggle_checkbox_answer(questionId, option, isChecked) {
        const questionSection = this.profile_questions
          ?.flatMap(f => f?.form?.form_sections || [])
          ?.flatMap(s => s?.section?.question_sections || [])
          ?.find(qs => qs?.question?.id === questionId);

        if (questionSection) {
          if (!Array.isArray(questionSection.answer)) {
            questionSection.answer = [];
          }

          if (isChecked) {
            if (!questionSection.answer.includes(option)) {
              questionSection.answer.push(option);
            }
          } else {
            questionSection.answer = questionSection.answer.filter(o => o !== option);
          }
        }
      },
      validateForm() {
        this.errors = {};

        if (!this.company_name) {
          this.errors.company_name = 'Company name is required.';
        }
        if (!this.selected_type_of_organization) {
          this.errors.type_of_organization_id = 'Type of organization is required.';
        }
        if ((this.email) && !/\S+@\S+\.\S+/.test(this.email)) {
          this.errors.email = 'Invalid email format.';
        }

        return Object.keys(this.errors).length === 0;
      },

      reset_company_form() {
        this.company_name = ''
        this.selected_type_of_organization = ''
        this.description = ''
        this.email = ''
        this.tell_number = ''
        this.location = ''

        // clear quill editor
        if (this.$refs.quillCompanyEditorRef) {
          this.$refs.quillCompanyEditorRef.setHTML('')
        }
      },

      saveCompanyProfile() {
        if (!this.validateForm()) {
          return;
        }
        Swal.fire({
            title: 'Submitting...',
            text: 'Please wait while we create the company profile.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        this.isLoading = true;

        const businessProfile = this.type_of_profile.find(
          (profile) => profile.name.toUpperCase() === 'BUSINESS'
        );

        const formData = new FormData();
        formData.append('company_name', this.company_name);
        formData.append('type_of_organization_id', this.selected_type_of_organization);
        this.description = this.$refs.quillCompanyEditorRef.getHTML()
        formData.append('description', this.description);
        formData.append('email', this.email|| '');
        formData.append('tell_number', this.tell_number|| '');
        formData.append('location', this.location|| '');
        formData.append('profile_type_id', businessProfile.id);

        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_company_profile/`,
            type: 'POST',
            headers: {
                Authorization: `Token ${get_token()}`,
            },
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
                if (response.status === 'success') {
                    Swal.fire({
                        title: 'Success',
                        text: 'Company Profile Created Successfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false,
                        position: 'bottom-end',
                        toast: true
                    }).then(() => {
                        if(this.user_details.first_time_login==='true'){
                          this.update_first_time_login_status()
                        }
                      this.$emit('business_profile_created');
                      $('#company_profile_modal').modal('hide');
                      this.reset_company_form();
                    });
                }
              this.switchProfile(response?.data?.company_data?.base_profile?.id,false);

            },
            error: (error) => {
                console.error('Error:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'An error occurred while creating the profile',
                    icon: 'error',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
            },
            complete: () => {
              this.fetchProfiles();
                this.isLoading = false;
            },
        });
    },
    fetch_type_of_organization() {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
      });
    },
    clear_company_form() {
      this.is_edit_mode = false;
      this.company_name = '';
      this.selected_type_of_organization = '';
      this.description = '';
      this.email = '';
      this.tell_number = '';
      this.location = '';
      this.base_profile_id = null;
      this.errors = {};
      // Clear Quill editor if ref exists
      this.$nextTick(() => {
        if (this.$refs.quillCompanyEditorRef) {
          if (typeof this.$refs.quillCompanyEditorRef.setHTML === 'function') {
            this.$refs.quillCompanyEditorRef.setHTML('');
          } else if (this.$refs.quillCompanyEditorRef.quill) {
            this.$refs.quillCompanyEditorRef.quill.root.innerHTML = '';
          }
        }
      });
    },


    update_user_settings() {
      this.isLoading = true;

      const payload = {
        receive_emails: !!this.receive_emails,
        receive_notifications: !!this.receive_notifications,
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_user_settings/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
        success: () => {
          Swal.fire({
            title: 'Success',
            text: 'Settings updated successfully',
            icon: 'success',
            timer: 1000,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            $('#notificationSettingsModal').modal('hide');
          });
        },
        error: (xhr) => {
          console.error("Update User Settings Error:", xhr.responseText);
          Swal.fire({
            title: 'Error',
            text: 'Failed to update settings. Please try again.',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    confirmDeactivation() {
      Swal.fire({
        title: 'Are you sure?',
        text: "You are about to deactivate your account. You can reactivate anytime by logging back in.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, deactivate it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.deactivateAccount();
        }
      });
    },
    deactivateAccount() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/deactivate_account/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === 'success') {
            Swal.fire({
              title: 'Deactivated!',
              text: response.message || 'Your account has been deactivated.',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              clear_token();
              window.location = '/sign_in_finale' // kick user out after deactivation
            });
          }
        },
        error: (error) => {
          Swal.fire({
            title: 'Error!',
            text: error.responseJSON?.message || 'Something went wrong',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },
    confirm_account_deletion() {
      Swal.fire({
        title: 'Delete account permanently?',
        text: 'This will permanently delete your account and cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteAccount();
        }
      });
    },
    deleteAccount() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/delete_account/`,
        type: 'DELETE',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === 'success') {
            Swal.fire({
              title: 'Account deleted',
              text: response.message || 'Your account has been deleted.',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              clear_token();
              window.location = '/sign_in_finale';
            });
          } else {
            Swal.fire({
              title: 'Error!',
              text: response.message || 'Could not delete your account. Please try again.',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        error: (error) => {
          Swal.fire({
            title: 'Error!',
            text: error.responseJSON?.message || 'Could not delete your account. Please try again.',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }
};
